export const tailMisc = {
  tabBottom: {
    checkins: `Check-ins`,
    checkinsProg: `Demnächst`,
    requests: `Anfragen`,
  },
  adminNav: {
    myAccount: `Mein Konto`,
  },
  loader: {
    title: `{reason} wird erstellt!`,
    defaultReason: `Unterkunft`,
    preparing: `Wir richten Ihre {reason} ein, bitte warten Sie einen Moment…`,
    calendar: `Kalender wird eingerichtet`,
    availability: `Verfügbarkeit wird geprüft`,
    prices: `Preise werden eingerichtet`,
    almostDone: `Fast geschafft, wir stellen Ihre {reason} fertig…`,
  },
};
